export enum BrandingSectionAlign{
    LEFT,
    CENTER,
    RIGHT
}
export class BrandingSectionRowDto{
    content: string;
    align: BrandingSectionAlign = BrandingSectionAlign.LEFT;
    size: number = 1;
    underline: boolean = false;
    bold: boolean = false;
}